import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BlogInfoTable } from "components/blog/detail";
import { AddBtn, PrimaryBtn } from "components/common/button";
import { getBlogDetail, postBlog, putBlog, delBlog } from "service/api/blog";
import type { IBlogList } from "service/interface/blog";
import responseCodeConstant from "service/constant/responseCodeConstant";
import { OneBtnModal, TwoBtnModal } from "components/common/modal";
import routerConstant from "service/constant/routerConstant";

export function BlogDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<IBlogList>({} as IBlogList);
  const [isSaveSuccessmodalVisible, setIsSaveSuccessModalVisible] =
    useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isDeleteSuccessModalVisible, setIsDeleteSuccessModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      if (params.id === "add") {
      } else {
        (async () => {
          const detailRes = await getBlogDetail(params.id + "");
          if (detailRes.status === responseCodeConstant.SUCCESS.ok) {
            setDetailData(detailRes.data.data);
          }
        })();
      }
    }
  }, [params]);

  const handleAddBtn = async () => {
    const addRes = await postBlog({
      type: detailData.type,
      imgSrc: detailData.imgSrc,
      title: detailData.title,
      link: detailData.link,
    });
    if (addRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSaveSuccessModalVisible(true);
    }
  };

  const handleSaveBtn = async () => {
    const saveRes = await putBlog({
      blogId: params.id,
      body: {
        type: detailData.type,
        title: detailData.title,
        imgSrc: detailData.imgSrc,
        link: detailData.link,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSaveSuccessModalVisible(true);
    }
  };

  const handleDeleteBtn = () => {
    setIsDeleteModalVisible(true);
  };

  const handleDeleteModalBtn = async () => {
    const delRes = await delBlog(params.id + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsDeleteSuccessModalVisible(true);
    }
  };

  const handleSuccessModalBtn = () => {
    navigate(routerConstant.BLOG.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSaveSuccessmodalVisible}
        setIsVisible={setIsSaveSuccessModalVisible}
        title={params.id === "add" ? "추가 완료" : "등록 완료"}
        subTitle="저장이 완료되었습니다"
        btnLabel="확인"
        btnClick={handleSuccessModalBtn}
      />
      <OneBtnModal
        isVisible={isDeleteSuccessModalVisible}
        setIsVisible={setIsDeleteSuccessModalVisible}
        title="삭제 완료"
        subTitle="삭제가 완료되었습니다"
        btnLabel="확인"
        btnClick={handleSuccessModalBtn}
      />
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="해당 리뷰를 삭제하시겠습니까?"
        subTitle=""
        btnLabel="삭제하기"
        btnClick={handleDeleteModalBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              블로그 컨텐츠
            </p>
            {params.id !== "add" && (
              <AddBtn isRemove onClick={handleDeleteBtn} />
            )}
          </div>
          <div className="mt-[32px] flex flex-col rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <BlogInfoTable data={detailData} setData={setDetailData} />
            <div className="mt-[24px] flex justify-end">
              <PrimaryBtn
                isDisabled={
                  !detailData.title || !detailData.type || !detailData.link
                }
                label={params.id === "add" ? "추가하기" : "저장하기"}
                onClick={params.id === "add" ? handleAddBtn : handleSaveBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
